import { v4 as uuidv4 } from "uuid";

export const isPlaceholder = col =>  col && col.type === "";
export const isPlaceholderRowContent = row => row.cols.length === 1 && isPlaceholder(row.cols[0]);
export const isPlaceholderRow = (layoutDefinition, row) =>
	layoutDefinition.length > row && row >= 0 && isPlaceholderRowContent(layoutDefinition[row]);
export const isEmptyRowContent = row => row.cols.length === 0;

export const removePlaceholderFromRow = row => {
	const newRow = { cols: [] };
	let didChange = false;
	for (const col of row.cols) {
		if (!isPlaceholder(col)) {
			newRow.cols.push(col);
		} else {
			didChange = true;
		}
	}
	for (const col of newRow.cols) {
		const newSize = 12 / newRow.cols.length;
		if (col) {
			if (col.size !== newSize) {
				col.size = newSize;
				didChange = true;
			}
		}
	}

	return [ newRow, didChange ];
};

export const removePlaceholdersFromRows = rows => {
	const newRows = [];
	let didRowsChange = false;
	for (const row of rows) {
		const [ newRow, didChange ] = removePlaceholderFromRow(row);
		didRowsChange = didRowsChange || didChange;
		if (!isEmptyRowContent(newRow)) {
			newRows.push(newRow);
		} else {
			didRowsChange = true;
		}
	}

	return [ newRows, didRowsChange ];
};

const toCurrentElement = currentElement => {
	const newElement = [];
	for (const col of currentElement.cols) {
		if (!isPlaceholder(col)) {
			newElement.push(col);
		}
	}

	return { ...currentElement, cols: newElement };
};

export const getEmptyElement = () => ({
	id: uuidv4(),
	cols: [
		{
			id: uuidv4(),
			type: "",
			placeholder: true,
		},
	],
});


export const cleanupFormDefinition = (current, placeholderProducer = getEmptyElement) => {
	const PLACEHOLDER = "placeholder";
	const ROW = "row";
	const newRowList = [];
	let expectNext = PLACEHOLDER;

	for (const currentElement of current) {
		if (isPlaceholderRowContent(currentElement)) {
			if (expectNext === PLACEHOLDER) {
				newRowList.push(currentElement);
				expectNext = ROW;
			} // otherwise ignore placeholder
		} else if (!isEmptyRowContent(currentElement)) {
			if (expectNext !== ROW) {
				newRowList.push(placeholderProducer());
			}
			newRowList.push(toCurrentElement(currentElement));
			expectNext = PLACEHOLDER;
		}
	}
	if (expectNext === PLACEHOLDER) {
		newRowList.push(placeholderProducer());
	}

	return newRowList;
};

export const separateQuestionAndNumber = configToUpdate => {
	let cayuseQuestionNumber = "";
	const label = configToUpdate?.i18n?.en_us?.label;	// eslint-disable-line camelcase
	if (label && label.includes(". ")) {
		let splitString = label.split(". ");
		cayuseQuestionNumber = splitString[0];
		configToUpdate.label = splitString[1];
	}

	return {
		cayuseShortLabel: "",
		cayuseQuestionNumber: cayuseQuestionNumber,
		isRequired: false,
		...configToUpdate
	};
};

export const concatQuestionAndNumber = (question, questionNumber) => {
	let concatenatedQuestion;
	if (question.includes(". ")) {
		let splitString = question.split(". ");
		concatenatedQuestion = questionNumber + ". " + splitString[1];
	} else if (questionNumber !== "") {
		concatenatedQuestion = questionNumber + ". " + question;
	} else {
		concatenatedQuestion = question;
	}

	return {
		cayuseQuestionNumber: questionNumber,
		label: concatenatedQuestion,
		// eslint-disable-next-line camelcase
		i18n: { en_us: { label: concatenatedQuestion } }
	};
};
